import { Link } from "react-router-dom";
import { ErrorText, Panel, Spinner } from "../../components/ui";
import { coverImage } from "./api";
import { useFeed } from "./hooks";

export function FeedPage() {
  const { data, isLoading, error } = useFeed();

  return (
    <Panel title="Actualités & opportunités">
      <ErrorText error={error} />
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="opportunity-grid">
          {data?.map((o) => {
            const cover = coverImage(o);
            return (
              <Link key={o.id} to={`/opportunities/${o.id}`} className="opportunity-card">
                {cover ? <img src={cover} alt="" /> : null}
                <div className="opportunity-card-body">
                  <span className="tag">{o.type}</span>
                  <h3>{o.title}</h3>
                  {o.summary && <p className="muted">{o.summary}</p>}
                </div>
              </Link>
            );
          })}
        </div>
      )}
      {data?.length === 0 && <p className="muted">Aucune opportunité pour l'instant.</p>}
    </Panel>
  );
}
